import { PocIcon } from 'commons/components/components-wrapper/poc-icon.component';
import {
    ConnectionStatus,
    ConnectionStatusCodes,
} from 'modules/settings/pods/settings-integrations/settings-integrations-active-directory/types/active-directory.type';

export const getListConnectionStatusIconName = (
    status: ConnectionStatus
): React.ComponentProps<typeof PocIcon>['name'] => {
    if (status === ConnectionStatusCodes.SUCCESS) {
        return 'connection_on';
    }
    return 'connection_off';
};

export const getListConnectionStatusIconStatus = (
    status: ConnectionStatus
): React.ComponentProps<typeof PocIcon>['status'] => {
    if (status === ConnectionStatusCodes.SUCCESS) {
        return 'positive';
    }
    if (status === ConnectionStatusCodes.PENDING) {
        return 'warning';
    }
    return 'alarm';
};

export const getListConnectionStatusLabel = (status: ConnectionStatus): string => {
    if (status === ConnectionStatusCodes.SUCCESS) {
        return 'settings.integrations.active-directory.list.connection-status.successful';
    }
    if (status === ConnectionStatusCodes.PENDING) {
        return 'settings.integrations.active-directory.list.connection-status.pending';
    }
    return 'settings.integrations.active-directory.list.connection-status.failed';
};
